import { render } from "./body.vue?vue&type=template&id=d754d862"
import script from "./body.vue?vue&type=script&lang=js"
export * from "./body.vue?vue&type=script&lang=js"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__